var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('button',{on:{"click":_vm.testMessage}},[_vm._v("Test message")]),_vm._v(" "+_vm._s(_vm.transportStatus)+" "),_c('div')])}
var staticRenderFns = []

export { render, staticRenderFns }